export default "__VITE_ASSET__Cqjyk$Vo__"